module.exports = __webpack_public_path__ + "img/2.d0da2b3b.png";